<template>
  <router-view />
</template>

<script>
import "bootstrap-vue/dist/bootstrap-vue.css";
import "bootstrap/dist/css/bootstrap.css";
import "@/assets/icomoon/style.css";
import("vue-it-bigger/dist/vue-it-bigger.min.css");

export default {};
</script>

<style lang="sass">
@import "@/assets/styles/style"
</style>
